import React from "react";
import DateTimeInput from "../fields/DateTimeInput";

const EMSTimeSection = ({ formData, setFormData }) => {
  return (
    <section className="form-section">
      <h3>2-1. EMS 신고~현장 이탈 시각</h3>

      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            EMS 신고 시각 (EMS_call_time)
          </label>
          <div className="input_2col">
            <DateTimeInput
              id="EMS_call_time"
              value={formData.EMS_call_time || ""}
              onChange={(datetime) =>
                setFormData({ ...formData, EMS_call_time: datetime })
              }
            />
          </div>
        </div>
        <div className="block-2column">
          <label className="item_title_2col">
            EMS 현장 도착 시각 (EMS_arrive_time)
          </label>
          <div className="input_2col">
            <DateTimeInput
              id="EMS_arrive_time"
              value={formData.EMS_arrive_time || ""}
              onChange={(datetime) =>
                setFormData({ ...formData, EMS_arrive_time: datetime })
              }
            />
          </div>
        </div>
      </div>

      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            2번째 구급차 도착 시각 (X2nd_arrive_time)
          </label>
          <div className="input_2col">
            <DateTimeInput
              id="X2nd_arrive_time"
              value={formData.X2nd_arrive_time || ""}
              onChange={(datetime) =>
                setFormData({ ...formData, X2nd_arrive_time: datetime })
              }
            />
          </div>
        </div>
        <div className="block-2column">
          <label className="item_title_2col">
            EMS 현장 이탈 시각 (EMS_Departure_time)
          </label>
          <div className="input_2col">
            <DateTimeInput
              id="EMS_Departure_time"
              value={formData.EMS_Departure_time || ""}
              onChange={(datetime) =>
                setFormData({ ...formData, EMS_Departure_time: datetime })
              }
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default EMSTimeSection;
